const _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { createContext, useContext, useMemo } from 'react';
import Lottie from 'lottie-react';
import { useStateInRef } from 'seagull';
import { makeMockIntercomClient } from "../intercom/intercomClient.mock";
import { actualReactStripeJs } from "../stripe/reactStripeJs";
import { mockSlackClient } from "../utils/slack-client";
import { mockCookiesManager } from "./CookiesManager";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
function throwUnsetContextError(f) {
  return () => {
    throw new Error("Somebody is trying to use ".concat(f, " without a properly set context"));
  };
}
export const mockHotjar = {
  identify() {}
};
export const mockOpenNewTab = () => null;
export const MockReactPlayer = () => /*#__PURE__*/_jsx(_Fragment, {});
export const MockYoutubePlayer = () => /*#__PURE__*/_jsx(_Fragment, {});
export const MockGoogleButton = () => /*#__PURE__*/_jsx(_Fragment, {});
export const MockLoomParser = async () => ({
  type: 'video',
  html: '',
  title: '',
  provider_name: 'Loom',
  provider_url: '',
  thumbnail_height: 0,
  thumbnail_width: 0,
  thumbnail_url: '',
  duration: 0,
  height: null,
  width: null
});
export class MockLocalStorage {
  constructor() {
    _defineProperty(this, "storage", {});
  }
  clear() {
    this.storage = {};
  }
  getItem(key) {
    return key in this.storage ? this.storage[key] : null;
  }
  removeItem(key) {
    delete this.storage[key];
  }
  setItem(key, value) {
    this.storage[key] = value;
  }
}
const Context = /*#__PURE__*/createContext({
  slackClient: mockSlackClient,
  getNow: throwUnsetContextError('getNow'),
  getTimezoneAbbreviation: throwUnsetContextError('getTimezoneAbbreviation'),
  usePlaidLink: throwUnsetContextError('usePlaidLink'),
  locationReload: throwUnsetContextError('locationReload'),
  changeLocation: () => {},
  copyToClipboard: throwUnsetContextError('copyToClipboard'),
  getHotjar: () => mockHotjar,
  openNewTab: mockOpenNewTab,
  personaClient: throwUnsetContextError('personaClient'),
  ReactPlayer: MockReactPlayer,
  YoutubePlayer: MockYoutubePlayer,
  Lottie: Lottie,
  GoogleButton: MockGoogleButton,
  loomParser: MockLoomParser,
  uploadFileToCloudStorage: async () => {},
  cookies: mockCookiesManager,
  logBIEventOld: () => {},
  logBIEvent: () => {},
  localStorage: new MockLocalStorage(),
  downloadCsv: () => {},
  reactStripe: actualReactStripeJs,
  injectScriptOrLink: async () => null,
  intercomClient: makeMockIntercomClient()
});
export function IoContextProvider(props) {
  const getProps = useStateInRef(props);
  const value = useMemo(() => {
    const _getProps = getProps(),
      {
        children: _
      } = _getProps,
      rest = _objectWithoutProperties(_getProps, _excluded);
    return rest;
  }, []);
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: value,
    children: props.children
  });
}
export const useIoContext = () => useContext(Context);
export default IoContextProvider;